import {
  anchorProduct,
  loadingPreviousProducts,
  previousProductsLoaded,
  loadingMoreProducts,
  moreProductsLoaded,
  requestProducts,
  receiveProducts,
} from "../../store/actionCreators";
import {
  anchorProductReducer,
  loadingPreviousProductsReducer,
  previousProductsLoadedReducer,
  loadingMoreProductsReducer,
  moreProductsLoadedReducer,
  requestProductsReducer,
  receiveProductsReducer,
} from "../reducers";

export const registerResultsSlice = (builder, dependencies) => {
  builder
    .addCase(anchorProduct, anchorProductReducer)
    .addCase(loadingPreviousProducts, (state) =>
      loadingPreviousProductsReducer(state, dependencies),
    )
    .addCase(previousProductsLoaded, (state, action) =>
      previousProductsLoadedReducer(state, action, dependencies),
    )
    .addCase(loadingMoreProducts, (state) =>
      loadingMoreProductsReducer(state, dependencies),
    )
    .addCase(moreProductsLoaded, (state, action) =>
      moreProductsLoadedReducer(state, action, dependencies),
    )
    .addCase(requestProducts, (state, action) =>
      requestProductsReducer(state, action, dependencies),
    )
    .addCase(receiveProducts, (state, action) =>
      receiveProductsReducer(state, action, dependencies),
    );
};
